module.exports = __webpack_public_path__ + "./fonts/Kalam-Regular.ttf";